import { RequestTypes } from '../../../hooks'

export const EXTENSION_API_PREFIX = '/api/extension/v1/'

export const REGION_MAP_INFO = 'extension/region-map-info/'
export const REGION_MAP_RENEWABLE_ENERGY_TYPES = 'extension/region-map-info/renewable-energy-types/'
export const REGION_MAP_ACCOUNTED_GENERATION = 'extension/region-map-info/accounted-generation/'
export const REGION_MAP_OWNERS = 'extension/region-map-info/regions-owners'

export const getRegionMapInfo = {
    link: `${EXTENSION_API_PREFIX}${REGION_MAP_INFO}`,
    method: RequestTypes.get,
}

export const getRegionMapRenewableEnergyTypes = {
    link: `${EXTENSION_API_PREFIX}${REGION_MAP_RENEWABLE_ENERGY_TYPES}`,
    method: RequestTypes.get,
}

export const getRegionMapAccountedGeneration = {
    link: `${EXTENSION_API_PREFIX}${REGION_MAP_ACCOUNTED_GENERATION}`,
    method: RequestTypes.get,
}

export const getRegionMapOwners = {
    link: `${EXTENSION_API_PREFIX}${REGION_MAP_OWNERS}`,
    method: RequestTypes.get,
}

export type RegionMapInfo = {
    region_id: number
    reg_count: number
    qualified_count: number
    reg_volume: number
    qualified_volume: number
}

export type AccountedGenerationEnergyType = {
    renewable_energy_type_id: number
    volume: number
}

export type AccountedGenerationInfo = {
    region_id: number
    total_volume: number
    energy_types: AccountedGenerationEnergyType[]
}

export type GoOwnerPower = {
    owner_name: string
    total_power_mw: number
}

export type EnergyTypeOwners = {
    energy_type_id: number
    owners: GoOwnerPower[]
}

export type RegionOwnerMapInfo = {
    region_id: number
    energy_types: EnergyTypeOwners[]
}
